import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';

export function useCreateUserPlant() {
  return useMutation(api.plants.mutations.createUserPlant).withOptimisticUpdate(
    (localStore, args) => {
      const current = localStore.getQuery(api.plants.queries.getAllPlants, {});
      if (current === undefined) return;

      const name = args.name.trim();
      if (!name) return;

      const optimisticId = `__opt_${Date.now()}`;
      localStore.setQuery(api.plants.queries.getAllPlants, {}, [
        ...current,
        {
          id: optimisticId,
          name,
          emoji: args.emoji.trim() || '🌱',
          category: args.category.trim() || 'Other',
          speciesId: optimisticId,
          speciesName: name,
          isUserOwned: true,
        },
      ]);
    }
  );
}
